<template>
	<div id="datenschutz" class='page'>

		<div class="page-content">

			<h1>{{p.headline}}</h1>
			<p>
				<div class="hinweis">
					{{footer['hinweis']}}
				</div>

			</p>
            <iframe src="https://www.terminland.de/studioforspace/?mode=frame" width="100%" height="650"

              scrolling="auto" marginwidth="0" marginheight="0" frameborder="0" vspace="0" hspace="0">

                <p>

                  Ihr Browser kann leider keine eingebetteten Frames anzeigen:

                  Sie können die Online-Terminbuchung über den folgenden Verweis aufrufen:

                  <a href="https://www.terminland.de/studioforspace/">Online-Terminbuchung</a>

                </p>

            </iframe>

		</div>
	</div>

</template>
<script>
	export default {
		name: 'termine',
		components: {
		},
		props: {
			langsufix: String,
			sidenav: Array,
			footer: Array,
		},
		data() {
			return {
				p: {}
			}
		},
		created () {
			this.getContent();
		},
		methods: {
            scrollToTop() {
                     window.scrollTo(0,0);
            },
			close () {
				this.$router.push('/');
			},
			getContent () {
				this.$prismic.client.getByUID('page-short','termine-'+this.langsufix)
				.then((document) => {
					console.log(document.data);
					this.p = document.data;
				})
			},
		}
	}
</script>

<style lang='less' scoped>
@import '../less/variables.less';
.hinweis {
	color: black;
	.fm(12px);
}
.page-content {
	width:80%;
	min-height: 800px;
	background-color: white;
	text-align: left;
	color: @g1;
	.fm(12px);
	padding: 100px 10%;

}
h1 {
	.fmb(40px);
	color: @g1;
}
p {
	.fm(12px);
	color: @g1;
}
.page {
	margin-top: 200px;
}
.bg {
	background-image: url('/images/bg_home.jpg');
}
.page-content {
	// width: 50%;

}

</style>
